import type { HomeActivationResponse } from "@/types_api/backend/transport/home_activation_response"

type GettingStartedCountKey = Exclude<
  keyof HomeActivationResponse,
  "conversation_count"
>

interface GettingStartedStep {
  id: string
  countKey: GettingStartedCountKey
  /** Full task wording for the sidebar checklist. */
  label: string
  /** Workspace-relative destination; build the href with `getHref`. */
  path: string
}

/** The sidebar onboarding checklist and its completion criteria. */
export const GETTING_STARTED_STEPS: readonly GettingStartedStep[] = [
  {
    id: "agent",
    countKey: "agent_count",
    label: "Connect an agent",
    path: "/agents/create",
  },
  {
    id: "persona",
    countKey: "persona_count",
    label: "Create a persona",
    path: "/personas?id=new",
  },
  {
    id: "test-set",
    countKey: "test_set_count",
    label: "Create a test set",
    path: "/test-sets/create",
  },
  {
    id: "metric",
    countKey: "metric_count",
    label: "Create a metric",
    path: "/metrics?create=true",
  },
  {
    id: "simulation",
    countKey: "simulation_count",
    label: "Run a simulation",
    path: "/simulate",
  },
  {
    id: "review",
    countKey: "human_review_project_count",
    label: "Create a Human Review project",
    path: "/review/projects",
  },
]

export function isGettingStartedStepComplete(
  step: GettingStartedStep,
  counts: Partial<HomeActivationResponse> | null | undefined,
): boolean {
  return (counts?.[step.countKey] ?? 0) > 0
}
